import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCustomerNotificationConfig(params) {
  return request({
    url: URL.sys.customerNotificationConfig,
    method: 'get',
    params: { 'branchId': params }
  })
}

export function saveCustomerNotificationConfig(data) {
  return request({
    url: URL.sys.customerNotificationConfig,
    method: 'post',
    data
  })
}
